import logo from './logo.svg';
import './App.css';
import { Portfolio } from './Components/Portfolio';
import { Skill } from './Components/TechSkills';
import { Header } from './Components/Header';
import { Homepage } from './Pages/Home';
import { AboutPage } from './Pages/About';
import { Footer } from './Components/Footer';
import { SkillsData } from './Components/SkillsData';
import Humberg from './Components/humberg';
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react"
import Statistics from './Pages/Statistics';

function App() {
  return (
    <div className="App">

        <Header/>
      <Homepage/>
      <AboutPage/>
     <Skill/>
     <Portfolio/>
    <Statistics/>
     <Footer/>
      {/* <SkillsData/> */}
    </div>
  );
}

export default App;
